
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"36","viewBox":"0 0 512 512","width":"36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M510.689 478.854c0 17.561-14.275 31.836-31.836 31.836H33.146c-17.559 0-31.836-14.275-31.836-31.836V33.146c0-17.56 14.277-31.836 31.836-31.836h445.707c17.561 0 31.836 14.276 31.836 31.836v445.708z","fill":"#ED1F24"}}),_c('path',{attrs:{"d":"M313.475 105.366h-45.648c-44.854 0-82.892 34.142-82.892 100.427 0 39.765 18.42 69.084 51.25 83.547l-61.262 110.869c-2.005 3.619 0 6.426 3.202 6.426h28.433c2.4 0 4.01-.801 4.81-2.807l55.659-108.863h20.021v108.863c0 1.197 1.197 2.807 2.799 2.807h24.832c2.4 0 3.203-1.205 3.203-3.205V109.383c-.001-2.812-1.603-4.017-4.407-4.017zM287.047 269.26h-16.818c-26.427 0-52.053-19.281-52.053-67.483 0-50.22 24.024-70.705 48.448-70.705h20.424V269.26z","fill":"#FFF"}})])
          )
        }
      }
    